export default __webpack_public_path__ + "static/media/15.2cffda33.jpg";